import { EMPTY_REQUEST_SERVICE_CODE_MODEL } from "presentation/model/RequestServiceCode/RequestServiceCodeModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: RequestServiceCodeProvider,
    useTracked: useRequestServiceCodeTracked
} = createContainer(() => useState(EMPTY_REQUEST_SERVICE_CODE_MODEL), { concurrentMode: true });
export { RequestServiceCodeProvider, useRequestServiceCodeTracked };

